var $89434176ab35446b$exports = {};
$89434176ab35446b$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`,
    "colorSwatchPicker": `Color swatches`
};


export {$89434176ab35446b$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
